import { Image } from "@mantine/core";
import { useMediaQuery } from "@mantine/hooks";
import { useContext } from "react";
import { Button } from "../../Button";
import { ThemeContext } from "../../context";
import {
  JiffyTestimonialHeading,
  JiffyTestimonialParagraph,
} from "../Testimonial/Testimonial.elements";
import {
  JiffyContainer,
  JiffyContent,
  ImageContainer,
  JiffyButtonContainer,
  RightCustomerContainer,
} from "./RightCustomers.elements";
import courierGetStarted from "../../../assets/svg/courierGetStarted.svg";

export const RightCustomers = () => {
  const { rooTheme } = useContext(ThemeContext);
  const matches = useMediaQuery("(max-width: 768px)");

  return (
    <RightCustomerContainer rooTheme={rooTheme}>
      <JiffyContainer>
        <JiffyContent>
          <JiffyTestimonialHeading rooTheme={rooTheme}>
            Get the right Customers
          </JiffyTestimonialHeading>
          <JiffyTestimonialParagraph rooTheme={rooTheme}>
            JIFFY helps you optimize and grow your 3pl business
          </JiffyTestimonialParagraph>
          <JiffyButtonContainer>
            <Button
              children={"Get Started"}
              background="#007FFF"
              color="#fff"
              type="button"
              paddingvals={"17.5px 30px"}
              //   formWidthButton={"20%"}
            />
          </JiffyButtonContainer>
        </JiffyContent>
        <ImageContainer>
          <div>
            <Image
              src={courierGetStarted}
              maw={matches ? "100%" : "90%"}
              mx="auto"
              fit="cover"
              alt="Jiffy Courier Get Started"
              withPlaceholder
            />
          </div>
        </ImageContainer>
      </JiffyContainer>
    </RightCustomerContainer>
  );
};
